module.exports = __webpack_public_path__ + "static/media/Titanium.57c3572b.png";